export default "__VITE_ASSET__5e1dbc4d__"